import React from 'react';
import { Grid } from '@mui/material';
import SearchableAutocomplete from '../../../SearchableAutocomplete';

export default function StudentSelection({
    value,
    onChange,
    editRecord,
    disabled,
    formKey
}) {
    return (
        <Grid item xs={12} md={6}>
            <SearchableAutocomplete
                apiUrl="/accounts/api/v1/profile/students/"
                label="هنرجو"
                placeholder="جستجوی هنرجو..."
                value={value}
                onChange={onChange}
                getOptionLabel={(option) => {
                    const user = option?.user;
                    if (!user) return '';
                    const first = user.first_name?.trim() || '';
                    const last = user.last_name?.trim() || '';
                    const full = `${first} ${last}`.trim();
                    return full || `هنرجو #${option.id}`;
                }}
                getOptionValue={(option) => option?.user?.id}
                initialOption={
                    editRecord?.student
                        ? {
                            id: editRecord.student.id,
                            user: {
                                id: editRecord.student.id,
                                first_name: editRecord.student.first_name,
                                last_name: editRecord.student.last_name,
                                email: editRecord.student.email,
                                mobile: editRecord.student.mobile,
                            },
                        }
                        : null
                }
                disabled={disabled}
                required={false}
                size="small"
                sx={{
                    '& .MuiInputBase-root': {
                        height: '40px',
                        direction: 'rtl',
                    },
                }}
            />
        </Grid>
    );
}

